import { render, staticRenderFns } from "./ManageVINMVS.vue?vue&type=template&id=1ef5c7f0&scoped=true&"
import script from "./ManageVINMVS.vue?vue&type=script&lang=js&"
export * from "./ManageVINMVS.vue?vue&type=script&lang=js&"
import style0 from "./ManageVINMVS.vue?vue&type=style&index=0&id=1ef5c7f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef5c7f0",
  null
  
)

export default component.exports